var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wheel-color",
      class: [
        "wheel-color_" + _vm.multiplierClass,
        { "is-winner": _vm.winMultiplier === _vm.multiplier },
      ],
    },
    [
      _c(
        "div",
        {
          staticClass: "wheel-color__header color-header",
          on: {
            click: function ($event) {
              return _vm.$emit("colorClicked")
            },
          },
        },
        [
          _c("div", { staticClass: "color-header__left" }, [
            _c("div", { staticClass: "color-header__title" }, [
              _vm._v(" " + _vm._s(_vm.displayMultiplier) + " "),
            ]),
            _c("div", { staticClass: "color-header__bank currency_USD" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.formatNumber(_vm.color ? _vm.color.totalBankUsd : 0)
                  ) +
                  " "
              ),
            ]),
          ]),
          _c("div", { staticClass: "color-header__users" }, [
            _c("div", {
              staticClass: "color-header__icon icon icon_users-bold",
            }),
            _c("div", { staticClass: "color-header__users-count" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.formatNumber(_vm.color ? _vm.color.usersCount : 0)
                  ) +
                  " "
              ),
            ]),
          ]),
        ]
      ),
      _c("div", { staticClass: "wheel-color__bets" }, [
        _vm.sortedBets.length > 0 || _vm.isLoading
          ? _c(
              "div",
              { staticClass: "wheel-color__scroll" },
              _vm._l(_vm.sortedBets, function (bet) {
                return _c("wheel-bet", {
                  key: bet.id,
                  attrs: {
                    bet: bet,
                    "is-won": _vm.winMultiplier === _vm.multiplier,
                  },
                })
              }),
              1
            )
          : _c("div", { staticClass: "empty-block" }, [
              _c("div", { staticClass: "empty-block__title" }, [
                _vm._v(" Empty "),
              ]),
            ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }